import { Form, FormInlined } from "../../business-objects/form/form.model";
import { JobType } from "../../business-objects/job-type/job-type.model";

export class NewJobPopoverResult {

    constructor(protected form: FormInlined, protected jobType: JobType) {

    }

    getForm(): FormInlined {
        return this.form;
    }

    getJobType(): JobType {
        return this.jobType;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/new-job-popover/new-job-popover-result.model.ts